import get from 'lodash.get';
import getIsB2C from './is-b2c';

const getYolaEditorURL = (rootState) => {
  if (getIsB2C(rootState)) {
    return get(rootState, 'config.common.yola-editor.url');
  }

  return get(rootState, 'config.common.yola-editor.wl_url');
};

export default getYolaEditorURL;
